import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ButtonComponent } from '@mode/capra';
import { GoogleSheetUploadFacade } from '@mode/dataset/google/contract';

@Component({
  standalone: true,
  selector: 'mode-upload-sheet-button',
  imports: [ButtonComponent],
  template: `<capra-button text="Upload a Google Sheet" icon="icon-plus-default" (clicked)="upload()"></capra-button> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadSheetButtonComponent {
  constructor(private _uploadSheetFacade: GoogleSheetUploadFacade) {}

  upload() {
    this._uploadSheetFacade.launchDialog();
  }
}
